import { render, staticRenderFns } from "./MyLightBox.vue?vue&type=template&id=d6197278"
import script from "./MyLightBox.vue?vue&type=script&lang=js"
export * from "./MyLightBox.vue?vue&type=script&lang=js"
import style0 from "./MyLightBox.vue?vue&type=style&index=0&id=d6197278&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLightboxCloseIcon: require('/usr/src/nuxt-app/components/elements/lightbox/CloseIcon.vue').default,ElementsLightboxLeftArrowIcon: require('/usr/src/nuxt-app/components/elements/lightbox/LeftArrowIcon.vue').default,ElementsLightboxRightArrowIcon: require('/usr/src/nuxt-app/components/elements/lightbox/RightArrowIcon.vue').default})
